export default "__VITE_ASSET__B$MHhzfO__"